import React, { useState } from "react";
import { Modal as AntModal, Button, message, Space } from "antd";
import styled from "styled-components";
import api from "../../../../../api/api";
import { CheckOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

const Modal = styled(AntModal)`
  .ant-modal-close-icon svg {
    font-size: 24px;
  }

  .ant-modal-title {
    color: #1e1e1e;
    font-size: 24px;
    font-weight: 700;
  }

  .ant-modal-body {
    font-size: 16px;
    font-weight: 400;
    color: #1d1014;
  }

  .ant-modal-footer {
    .ant-btn {
      width: 100%;
      height: 56px;
    }

    .ant-space {
      width: 100%;
      gap: 16px !important;

      .ant-space-item {
        flex: 1;
      }
    }
  }
`;

const UpdateStatusModal = ({ id, open, handleClose, successCallback }) => {
  const [loading, setLoading] = useState(false);

  const handleClicked = () => {
    if (!loading) {
      setLoading(true);
      api
        .updateCountryStatus(id)
        .then(() => {
          setLoading(false);
          message.success(t('change_status_successfully'));
          handleClose();
          successCallback(id);
        })
        .catch((error) => {
          setLoading(false);
          message.error(error);
        });
    }
  };

  const onCancel = () => {
    !loading && handleClose();
  };

  const {t} = useTranslation();

  return (
    <Modal
      centered
      width={500}
      open={open}
      onCancel={onCancel}
      title={t('change_country_status')}
      footer={
        <Space>
          <Button type="default" onClick={onCancel}>
            {t('cancel')}
          </Button>
          <Button
            type="primary"
            icon={<CheckOutlined />}
            onClick={handleClicked}
          >
            {t('continue')}
          </Button>
        </Space>
      }
    >
      {t('country_status_change')}
    </Modal>
  );
};

export default UpdateStatusModal;
